import React, { memo } from "react";
import logo from "@/static/noBgBlack.svg";
import { useAuth0 } from "@auth0/auth0-react";
import { useSnapshot } from "valtio";
import { message } from "antd";
import FeatureCard from "@/pages/Charge/FeatureCard";
import PriceCard from "@/pages/Charge/PriceCard";
import FunctionCard from "@/pages/Charge/FunctionCard";
import { supabaseAuthStore } from "@/utils/store/supabaseAuth";
import {
    AlignRightOutlined,
    CheckCircleFilled,
    EllipsisOutlined,
    ExportOutlined,
    SnippetsOutlined
} from "@ant-design/icons";

interface Props {
}

const Index: React.FC<Props> = memo(() => {
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  return (
    <div className="bg-gradient-to-b from-slate-50 to-gray-100 min-h-full">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="flex flex-col gap-8">
          {/* 特性卡片区域 */}
          <div className="grid grid-cols-5 gap-4">
            <FeatureCard title={"会议记录快人一步"} desc={"支持会议纪要初稿、录音转文字同步上传，一键生成结构化内容"}/>
            <FeatureCard title={"调研讨论有据可查"} desc={"自动提炼关键信息点，快速整理讨论内容，形成备忘和输出初稿"}/>
            <FeatureCard title={"研判决策更聚焦"} desc={"支持提取核心观点与事实依据，协助推进立项、投研、尽调、业务分析等流程"}/>
            <FeatureCard title={"跟进事项不再遗漏"} desc={"自动识别行动项与责任人，生成跟进记录，适配投后、客户管理、项目进展"}/>
            <FeatureCard title={"总结汇报一键导出"} desc={"支持一键生成纪要 Word，供复盘、汇报、对外沟通使用"}/>
          </div>
          
          {/* 价格卡片区域 */}
          <div className="flex justify-center">
            <div className="w-96">
              <PriceCard title={"11"} desc={"22"}/>
            </div>
          </div>
          
          {/* 功能卡片区域 */}
          <div className="grid grid-cols-4 gap-4">
            <FunctionCard icon={<SnippetsOutlined style={{color: "#6B7280", fontSize: "28px"}}/>} title={"录音转文字"} desc={"准确率98%"}/>
            <FunctionCard icon={<AlignRightOutlined style={{color: "#6B7280", fontSize: "28px"}}/>} title={"AI整理内容"} desc={"摘要、问答、关键词"}/>
            <FunctionCard icon={<ExportOutlined style={{color: "#6B7280", fontSize: "28px"}}/>} title={"文稿编辑与导出"} desc={"支持Word/TXT"}/>
            <FunctionCard icon={<EllipsisOutlined style={{color: "#6B7280", fontSize: "28px"}}/>} title={"更多功能预告"} desc={"悬浮字幕、灵感记录等"}/>
          </div>
        </div>
      </div>
    </div>
  );
});
Index.displayName = "Index";

export default Index;